import { render, staticRenderFns } from "./03.vue?vue&type=template&id=54fa5ddc&scoped=true&"
import script from "./03.vue?vue&type=script&lang=js&"
export * from "./03.vue?vue&type=script&lang=js&"
import style0 from "./03.vue?vue&type=style&index=0&id=54fa5ddc&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa5ddc",
  null
  
)

export default component.exports